import React from "react";
import {
  Typography,
  TextField,
  Grid,
  Button,
  Select,
  Input,
  InputLabel,
  MenuItem,
  InputAdornment,
  Tooltip,
  IconButton,
  Autocomplete,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import LoopIcon from "@mui/icons-material/Loop";
import InfoIcon from "@mui/icons-material/Info";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  iconButton: {
    padding: 10,
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600)]: {
      width: 900,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

export const Fees = (props) => {
  const {
    customer,
    feeInfo,
    feesMethod,
    feesType,
    warehouses,
    categories,
    feesBase,
    handleChangeCustomerFee,
    handleChangeFee,
    handleClickAddFee,
    handleClickDeleteFee,
    handleChangeFeesBase,
    productsFees,
    handleChangeProductAuto,
    productsOptions,
    isLoading,
  } = props;

  const classes = useStyles();

  const handleSwitchPrice = () => {
    const unitOPrice =
      feeInfo.product.weight_type === "" || feeInfo.product.weight_type === null
        ? feeInfo.product.base_unit_price
        : feeInfo.product.base_unit_price_per_lb;
    const caseOPrice =
      feeInfo.product.weight_type === "" || feeInfo.product.weight_type === null
        ? feeInfo.product.base_case_price
        : feeInfo.product.base_case_price_per_lb;

    const newOPrice =
      feeInfo.oprice === "" || feeInfo.oprice !== unitOPrice
        ? unitOPrice
        : caseOPrice;

    handleChangeFee({ target: { name: "oprice", value: newOPrice } });
  };

  return (
    <div className={classes.paper}>
      <Grid container spacing={3} sx={{ textAlign: "center" }}>
        <Grid
          item
          xs={12}
          style={{ textAlign: "center", alignContent: "center" }}
        >
          <Button
            variant="text"
            color={feesBase === 0 ? "primary" : "inherit"}
            onClick={() => handleChangeFeesBase(0)}
          >
            Location Wide
          </Button>
          <Button
            variant="text"
            color={feesBase === 1 ? "primary" : "inherit"}
            onClick={() => handleChangeFeesBase(1)}
          >
            Per Product
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Typography color="primary" component="h4">
            <b>
              {feesBase === 0 ? "Location Wide margins" : "Per product margins"}
            </b>
            {feesBase === 1 && (
              <Tooltip title="Final Price is the price of the product that the customer sees on their order guide after all margins (company location and per product) have been applied. Base Price is the price of the product after company location margins have been applied">
                <IconButton>
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            )}
          </Typography>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
      {customer.margins.length === 0 ||
      customer.margins.every((item) => item.deleted) ? (
        <Typography
          color="primary"
          component="h4"
          style={{ textAlign: "center" }}
        >
          <b>There are no margins added</b>
        </Typography>
      ) : (
        customer.margins
          .filter((item) => !item.hidden)
          .map((item, idx) =>
            item.deleted ? null : (
              <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                spacing={2}
                key={"margin-" + item.id + "-" + idx}
              >
                <Grid item xs={item.category !== null ? 11 : 12}>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    sx={{
                      marginTop: 2,
                      background:
                        item.category !== null ? "#e9e9e9" : "#f9f9f9",
                      paddingRight: item.category !== null ? 2 : 2,
                      paddingBottom: 3,
                      border: "1px solid #aaa",
                      borderRadius: 3,
                    }}
                  >
                    <Grid item xs={true} sm={true}>
                      <Typography color="primary" component="h4">
                        Margin
                        {item.description ? (
                          <i>{` "${item.description}"`}</i>
                        ) : (
                          ` ${item.id || "new"}`
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={"auto"}>
                      <Tooltip title="Delete">
                        <IconButton
                          aria-label="delete"
                          onClick={() =>
                            handleClickDeleteFee(`margin-${item.id}`)
                          }
                          sx={{ color: "red" }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} sx={{ padding: "0 !important" }}></Grid>
                    <Grid item xs={12} sm={item.product !== null ? 3 : 6}>
                      <InputLabel shrink id="calculationMethodLabel">
                        Calculation Method
                      </InputLabel>
                      <Select
                        fullWidth
                        name={"margin-type-" + item.id}
                        input={<Input />}
                        value={item.type && item.type}
                        onChange={handleChangeCustomerFee("margin", item.id)}
                      >
                        {feesMethod.map((feeMethod) => (
                          <MenuItem
                            key={"margin-type-" + item.id + "-" + feeMethod}
                            value={feeMethod}
                          >
                            {feeMethod === "f" ? "Flat" : "Percentage"}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item xs={12} sm={item.product !== null ? 3 : 6}>
                      <TextField
                        fullWidth
                        type="number"
                        size="small"
                        required={true}
                        variant="outlined"
                        label={`${item.type !== "f" ? "Percentage" : "Flat"}`}
                        name={"margin-amount-" + item.id}
                        InputProps={{
                          startAdornment: ["", "f"].includes(item.type) ? (
                            <InputAdornment position="start">$</InputAdornment>
                          ) : (
                            <></>
                          ),
                          endAdornment: !["", "f"].includes(item.type) ? (
                            <InputAdornment position="start">%</InputAdornment>
                          ) : (
                            <></>
                          ),
                        }}
                        value={item.amount && item.amount}
                        onChange={handleChangeCustomerFee("margin", item.id)}
                      />
                    </Grid>
                    {item.product !== null && (
                      <>
                        <Grid item xs={12} sm={3}>
                          <TextField
                            fullWidth
                            type="number"
                            size="small"
                            required={true}
                            variant="outlined"
                            label="Final Price"
                            name={"margin-aprice-" + item.id}
                            value={item.aprice && item.aprice}
                            onChange={handleChangeCustomerFee(
                              "margin",
                              item.id,
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <TextField
                            fullWidth
                            type="number"
                            size="small"
                            variant="outlined"
                            label="Base Price"
                            name={"margin-oprice-" + item.id}
                            value={item.oprice && item.oprice}
                            style={{ background: "#eee" }}
                            disabled={true}
                            sx={{
                              "& .MuiInputBase-input.Mui-disabled": {
                                opacity: 1,
                                WebkitTextFillColor: "#000",
                              },
                              "& .MuiInputLabel-root.Mui-disabled": {
                                color: "rgba(0, 0, 0, 0.6)",
                              },
                              "& .MuiOutlinedInput-notchedOutline.Mui-disabled":
                                {
                                  borderColor: "rgba(0, 0, 0, 0.23)",
                                },
                            }}
                          />
                        </Grid>
                      </>
                    )}
                    {item.product !== null ? (
                      <Grid item xs={12} sm={6}>
                        <InputLabel shrink id="productLabel">
                          Products
                        </InputLabel>
                        <Autocomplete
                          fullWidth
                          size="small"
                          name={"margin-product-" + item.id}
                          options={productsOptions}
                          getOptionLabel={(option) =>
                            `${option.name} | (${option.upc}) #${
                              option?.item_code?.item_code ||
                              option?.item_code ||
                              ""
                            }#`
                          }
                          renderOption={(props, option) => (
                            <li {...props}>
                              {`${option.name} | (${option.upc}) #${
                                option?.item_code?.item_code ||
                                option?.item_code ||
                                ""
                              }# Stock: ${option.stock_level || 0}`}
                            </li>
                          )}
                          getOptionDisabled={(option) =>
                            productsFees.some((item) => item.upc === option.upc)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              variant="standard"
                            />
                          )}
                          isOptionEqualToValue={(option, value) => {
                            if (value.hasOwnProperty("upc")) {
                              return option.upc === value.upc;
                            } else {
                              return option.upc === value;
                            }
                          }}
                          value={item && item.product}
                          onChange={handleChangeCustomerFee(
                            "margin",
                            item.id,
                            "product",
                          )}
                          onInputChange={(e, v) =>
                            handleChangeProductAuto(e, v)
                          }
                          loading={isLoading}
                        />
                      </Grid>
                    ) : (
                      <>
                        <Grid item xs={12} sm={3}>
                          <InputLabel shrink id="warehouseLabel">
                            Warehouse
                          </InputLabel>
                          <Select
                            fullWidth
                            name={"margin-warehouseId-" + item.id}
                            input={<Input />}
                            value={item && item.warehouseId}
                            onChange={handleChangeCustomerFee(
                              "margin",
                              item.id,
                            )}
                          >
                            {warehouses.map((warehouse) => (
                              <MenuItem
                                key={
                                  "margin-warehouseId-" +
                                  item.id +
                                  "-" +
                                  warehouse.id
                                }
                                value={warehouse.id}
                              >
                                {warehouse.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <InputLabel shrink id="categoryLabel">
                            FF Department
                          </InputLabel>
                          <Autocomplete
                            fullWidth
                            name={`margin-category-${item.id}`}
                            input={<Input fullWidth />}
                            value={item && item.category}
                            options={categories}
                            getOptionLabel={(option) => `${option.name}`}
                            renderOption={(props, option) => (
                              <li
                                {...props}
                                key={option.id}
                                style={{
                                  paddingLeft: `${16 + option.depth * 20}px`,
                                  color:
                                    option.depth === 0
                                      ? "#000"
                                      : option.depth === 1
                                        ? "#333"
                                        : "#666",
                                  fontSize: `${14 - option.depth * 1}px`,
                                  fontWeight:
                                    option.depth === 0
                                      ? 600
                                      : option.depth === 1
                                        ? 500
                                        : 400,
                                }}
                              >
                                <span
                                  style={{
                                    marginRight: 8,
                                    opacity: 0.6,
                                    fontWeight: 400,
                                  }}
                                >
                                  {option.depth === 1
                                    ? "→ "
                                    : option.depth === 2
                                      ? "↳ "
                                      : ""}
                                </span>
                                {option.name}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                variant="standard"
                              />
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={handleChangeCustomerFee(
                              "margin",
                              item.id,
                              "category",
                            )}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        size="small"
                        required={true}
                        variant="outlined"
                        label="Description"
                        name={"margin-description-" + item.id}
                        value={item && item.description}
                        onChange={handleChangeCustomerFee("margin", item.id)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ),
          )
      )}
      {/* todo: organize add fee form (don't repeat description and amount) */}
      <Grid
        container
        spacing={2}
        style={{ alignItems: "center", marginTop: 24 }}
      >
        <Grid
          container
          alignItems={"center"}
          style={{ justifyContent: "center" }}
        >
          <Typography color="primary" component="h4">
            <b>Add a fee with the following information</b>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel shrink id="feeTypeLabel">
            Fee Type
          </InputLabel>
          <Select
            fullWidth
            key="fee_type"
            name="fee_type"
            input={<Input />}
            value={feeInfo && feeInfo.fee_type}
            onChange={handleChangeFee}
          >
            {feesType.map((item) => (
              <MenuItem key={"fee_type_" + item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel shrink id="calculationMethodLabel">
            Calculation Method
          </InputLabel>
          <Select
            fullWidth
            key="type"
            name="type"
            input={<Input />}
            value={feeInfo && feeInfo.type}
            onChange={handleChangeFee}
          >
            {feesMethod.map((item) => (
              <MenuItem key={"type_" + item} value={item}>
                {item === "f" ? "Flat" : "Percentage"}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        {feesBase === 1 ? (
          <>
            <Grid item xs={12} sm={6}>
              <InputLabel shrink id="productLabel">
                Products
              </InputLabel>
              <Autocomplete
                fullWidth
                size="small"
                name="product"
                options={productsOptions}
                getOptionLabel={(option) =>
                  `${option.name} | (${option.upc}) #${option?.item_code?.item_code || option?.item_code || ""}#`
                }
                renderOption={(props, option) => (
                  <li {...props}>
                    {`${option.name} | (${option.upc}) #${
                      option?.item_code?.item_code || option?.item_code || ""
                    }# Stock: ${option.stock_level || 0}`}
                  </li>
                )}
                getOptionDisabled={(option) =>
                  productsFees.some((item) => item.upc === option.upc)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="standard"
                    helperText={
                      feeInfo.product === null
                        ? "Select a product first to unlock Flat and Final Price fields"
                        : ""
                    }
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.upc === value.upc
                }
                value={feeInfo && feeInfo.product}
                onChange={(e, v) =>
                  handleChangeFee({ target: { name: "product" } }, v)
                }
                onInputChange={(e, v) => handleChangeProductAuto(e, v)}
                loading={isLoading}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                id="description"
                variant="outlined"
                label="Description"
                name="description"
                value={feeInfo && feeInfo.description}
                onChange={handleChangeFee}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="number"
                size="small"
                id="amount"
                variant="outlined"
                label={`${
                  ["", "f"].includes(feeInfo.type) ? "Flat" : "Percentage"
                }`}
                name="amount"
                InputProps={{
                  startAdornment: ["", "f"].includes(feeInfo.type) ? (
                    <InputAdornment position="start">$</InputAdornment>
                  ) : (
                    <></>
                  ),
                  endAdornment: !["", "f"].includes(feeInfo.type) ? (
                    <InputAdornment position="start">%</InputAdornment>
                  ) : (
                    <></>
                  ),
                }}
                value={feeInfo && feeInfo.amount}
                onChange={handleChangeFee}
                disabled={feesBase === 1 ? feeInfo.product === null : false}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="number"
                size="small"
                id="final-price"
                variant="outlined"
                label="Final Price"
                name="aprice"
                value={feeInfo && feeInfo.aprice}
                onChange={handleChangeFee}
                disabled={feesBase === 1 ? feeInfo.product === null : false}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={
                feeInfo.product && feeInfo.product.unit_type === "Unit / Case"
                  ? 3
                  : 4
              }
            >
              <TextField
                fullWidth
                type="number"
                size="small"
                id="base-price"
                variant="outlined"
                label="Base Price"
                name="oprice"
                value={feeInfo && feeInfo.oprice}
                style={{ background: "#eee" }}
                disabled={true}
                sx={{
                  "& .MuiInputBase-input.Mui-disabled": {
                    opacity: 1,
                    WebkitTextFillColor: "#000",
                  },
                  "& .MuiInputLabel-root.Mui-disabled": {
                    color: "rgba(0, 0, 0, 0.6)",
                  },
                  "& .MuiOutlinedInput-notchedOutline.Mui-disabled": {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                }}
              />
            </Grid>
            {feeInfo.product && feeInfo.product.unit_type === "Unit / Case" && (
              <Grid item xs={12} sm={1}>
                <Tooltip title="Switch Unit Type Price">
                  <IconButton
                    aria-label="switch"
                    disabled={feeInfo.product === null}
                    onClick={() => handleSwitchPrice()}
                  >
                    <LoopIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </>
        ) : (
          <></>
        )}
        {feesBase === 0 ? (
          <>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                size="small"
                id="amount"
                variant="outlined"
                label={`${
                  ["", "f"].includes(feeInfo.type) ? "Flat" : "Percentage"
                }`}
                name="amount"
                InputProps={{
                  startAdornment: ["", "f"].includes(feeInfo.type) ? (
                    <InputAdornment position="start">$</InputAdornment>
                  ) : (
                    <></>
                  ),
                  endAdornment: !["", "f"].includes(feeInfo.type) ? (
                    <InputAdornment position="start">%</InputAdornment>
                  ) : (
                    <></>
                  ),
                }}
                value={feeInfo && feeInfo.amount}
                onChange={handleChangeFee}
                disabled={feesBase === 1 ? feeInfo.product === null : false}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <InputLabel shrink id="warehouseLabel">
                Warehouse
              </InputLabel>
              <Select
                fullWidth
                key="warehouse"
                name="warehouse"
                input={<Input />}
                value={feeInfo && feeInfo.warehouse}
                onChange={handleChangeFee}
              >
                {warehouses.map((item) => (
                  <MenuItem key={"warehouse_" + item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={3}>
              <InputLabel shrink id="categoryLabel">
                FF Department
              </InputLabel>
              <Autocomplete
                fullWidth
                name="category"
                input={<Input fullWidth />}
                value={feeInfo && feeInfo.category}
                options={categories}
                getOptionLabel={(option) => `${option.name}`}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    key={option.id}
                    style={{
                      paddingLeft: `${16 + option.depth * 20}px`,
                      color:
                        option.depth === 0
                          ? "#000"
                          : option.depth === 1
                            ? "#333"
                            : "#666",
                      fontSize: `${14 - option.depth * 1}px`,
                      fontWeight:
                        option.depth === 0
                          ? 600
                          : option.depth === 1
                            ? 500
                            : 400,
                    }}
                  >
                    <span
                      style={{
                        marginRight: 8,
                        opacity: 0.6,
                        fontWeight: 400,
                      }}
                    >
                      {option.depth === 1
                        ? "→ "
                        : option.depth === 2
                          ? "↳ "
                          : ""}
                    </span>
                    {option.name}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} size="small" variant="standard" />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(e, v) =>
                  handleChangeFee({ target: { name: "category" } }, v)
                }
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                size="small"
                id="description"
                variant="outlined"
                label="Description"
                name="description"
                value={feeInfo && feeInfo.description}
                onChange={handleChangeFee}
              />
            </Grid>
          </>
        ) : (
          <></>
        )}
        <Grid container style={{ justifyContent: "flex-end" }}>
          <Button
            style={{
              minWidth: "auto",
              marginTop: 10,
              padding: "6px 10px",
            }}
            variant="contained"
            color="primary"
            onClick={handleClickAddFee}
            disabled={
              feeInfo.type === "" ||
              feeInfo.amount === "" ||
              (feesBase === 0
                ? feeInfo.warehouse === ""
                : feeInfo.product === null)
            }
          >
            Add
            {`${
              ["", "margin"].includes(feeInfo.fee_type)
                ? " Margin"
                : " Surcharge"
            }`}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default Fees;
